import { get, put, post } from '@aws-amplify/api';
import { restApiName } from '../config';
import { ATTR_TYPE_PARSERS, CODE_MAPS } from "../util/codeMaps";

export const getCodes = async (codeMapName) => {
    const response = await get({ apiName: restApiName, path: `/codes/${codeMapName}` }).response;
    const data =  await response.body.json();
    return data.codes;
};
export const putCode = async (codeMapName, record) => {
    const params = {
        body: {},
    }
    CODE_MAPS[codeMapName].attributes.forEach(attr => {
        const parser = ATTR_TYPE_PARSERS[attr.type];
        params.body[attr.name] = parser ? parser(record[attr.name]) : record[attr.name];
    });
    const { body } = await put({ apiName: restApiName, path: `/codes/${codeMapName}/${record.code}`, options: params }).response;
    return body.json();
};

export const promoteCodes = async (codeMapName, dryRun = true) => {
    const params = {
        body: { dryRun }
    };
    const { body } = await post({ apiName: restApiName, path: `/codes/${codeMapName}/promote`, options: params }).response;
    return body.json();
}
